import { combineReducers } from "redux";
import { LOGOUT } from "../types";
import loadingReducer from "./loadingReducer";
import authReducer from "./authReducer";
import adminReducer from "./adminReducer";
import userAuthReducer from "./userAuthReducer";
import userReducer from "./userReducer";

const appReducer = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    admin: adminReducer,
    user: userAuthReducer,
    userProfile: userReducer,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
